import { jsx as _jsx } from "react/jsx-runtime";
// -------------------------------------------------------
// NOTE: This is a generated file, do not manually modify!
// -------------------------------------------------------
import { SvgIcon } from '@mui/material';
const paths = [
    'M9.66243 8.19918L6.90203 10.9174C6.7919 11.0275 6.61381 11.0275 6.50367 10.9174L6.3373 10.751C6.22717 10.6409 6.22717 10.4628 6.3373 10.3527L8.73449 8L6.33964 5.64733C6.22951 5.5372 6.22951 5.35911 6.33964 5.24897L6.50602 5.0826C6.61615 4.97247 6.79424 4.97247 6.90438 5.0826L9.66478 7.80082C9.77257 7.91095 9.77257 8.08905 9.66243 8.19918Z',
];
export const AngleRight = (props) => (_jsx(SvgIcon, Object.assign({ viewBox: "0 0 16 16" }, props, { children: paths.map((pathString, i) => (_jsx("path", { d: pathString }, i))) })));
AngleRight.iconCategory = 'ui';
